import { render, staticRenderFns } from "./OrtItem.vue?vue&type=template&id=3ade06dc&"
import script from "./OrtItem.vue?vue&type=script&lang=js&"
export * from "./OrtItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports